export default {
  label: "Benutzerverwaltung",
  userAuthorization: "User Authorization",
  tabs: {
    pendingUserRequests: "Ausstehende Benutzeranfragen",
    userAndRolesAssignment: "Benutzer- und Rollenzuweisung",
  },
  assignRolesToUser: {
    label: "Rollen zu Benutzer Zuweisung",
  },
  userRoleManager: {
    inviteUser: "Benutzer einladen",
    label: "Benutzer-Rollenmanager",
    roleName: "Rollenname",
    selectRole: "Select Role",
    backToUM: "Zurück zur Benutzerverwaltung",
    backToUserRolesManager: "Zurück zum Benutzer-Rollenmanager",
    assignedTo: "Zugewiesen an",
    noUsersAssignedMessage: "Es gibt noch keine Benutzer, die dieser Rolle zugeordnet sind.",
    permissions: "Berechtigungen",
    createdUserRole: "Ihre Benutzerrolle wurde erfolgreich erstellt.",
    useRoleCreate: "Benutzerrolle erstellt",
    discardChanges: "Änderungen verwerfen",
    discardMessage:
      "Sie haben Änderungen vorgenommen, die nicht gespeichert sind. Sind Sie sicher, dass Sie diese Seite verlassen und die Änderungen ungespeichert lassen wollen?",
  },
  button: {
    create: {
      role: "Neue Rolle",
      user: "Benutzer erstellen",
    },
  },
  form: {
    label: {
      role: "Rolle bearbeiten",
      user: "Benutzer bearbeiten",
      deleteUserRole: "Benutzerrolle löschen",
      editRole: "Rolle bearbeiten",
    },
    message: {
      continueDeleteMessage: "Sind Sie sicher, dass Sie weitermachen wollen?",
      userRoleDeleteMessagePt1: "Diese Benutzerrolle ist derzeit zugewiesen an",
      userBlockMessage: "Sind Sie sich sicher dass Sie diesen Benutzer blockieren möchten?",
      userUnblockMessage: "Sind Sie sich sicher dass Sie diesen Benutzer entsperren möchten?",
      userRoleDeleteMessagePt2: "Sie werden keinen Zugang mehr zu bestimmten App-Bereichen haben.",
      userCreationSshAccess:
        "Der neue Benutzer kann nur über SSH-Schlüssel auf die Anwendung zugreifen. Die Anmeldung ist jedoch deaktiviert, bis der Benutzer im Identity Access Management-Provider erstellt wurde.",
      userCreationIdamRequired:
        "Bitte schließen Sie zuerst die Benutzererstellung im Identity Access Management-Provider ab, um den Standard-Anmeldezugang zu aktivieren.",
    },
    edit: {
      tabLabel: {
        editRole: "Rolle ändern",
        assignScope: "Berechtigungen zuordnen",
        assignUser: "Benutzer zuordnen",
      },
      listLabel: {
        assigned: "Zugeordnet",
        unassigned: "Verfügbar",
      },
    },
  },
  table: {
    column: {
      description: "Beschreibung",
      email: "Email",
      firstName: "Vorname",
      lastName: "Nachname",
      name: "Name",
      role: "Rollen des Benutzers",
      tenant: "Mieter / Unternehmen",
      value: "Wert",
      userRole: "Name der Benutzerrolle",
      roleDescription: "Beschreibung der Rolle",
      pendingRequestsAction: "Aktionen",
    },
  },
};
